import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { actions } from '../redux/modules/authentication'

const propTypes = {}

class App extends Component {
  render() {
    const { props } = this
    return <div className="h-100">{props.children}</div>
  }
}

const mapStateToProps = (state, { location }) => ({
  location,
  user: state.authentication.user
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  logout: () => dispatch(actions.logout())
})

App.propTypes = propTypes

export const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App)
export default withRouter(ConnectedApp)



// WEBPACK FOOTER //
// ./src/containers/App.js